import { createApp } from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import * as VueRouter from 'vue-router'

import { loadFonts } from './plugins/webfontloader'
import { createPinia } from 'pinia'
import WaveUI from 'wave-ui'
import 'wave-ui/dist/wave-ui.css'
import vue3GoogleLogin from 'vue3-google-login'
import router from './router/index'
import VuePdf from 'vue3-pdfjs'
import VueZoomer from 'vue-zoomer'
import LoadScript from "vue-plugin-load-script";
const pinia = createPinia()
const app = createApp(App)
  .use(VueAxios, axios)
  .use(router)
  .use(pinia)
  .use(VuePdf)
  .use(router)
  .use(VueZoomer)
  .use(LoadScript)
  // .use(vuetify)
  .use(vue3GoogleLogin, {
  //  clientId:'101614418197803331552',
    clientId: '60798862621-3cs7vh9jnl688o2erlc6jgr0d29u9int.apps.googleusercontent.com',
    IdConfiguration: { hosted_domain: "whirlpool.com" },
    popupType: "TOKEN"


  })
new WaveUI(app, {});
app.mount('#app')
// "@vue/cli-plugin-babel": "~5.0.8",
// "@vue/cli-plugin-router": "~5.0.0",
// "@vue/cli-plugin-typescript": "~5.0.0",
// "@vue/cli-service": "~5.0.8",
//  "sass-loader": "^13.2.0",